(() => {
  if (window.FeaturedProductSlider) return;

  class FeaturedProductSlider {
    constructor(parent) {
      if (!parent) return;

      this.parent = parent;
      this.init();
    }

    init() {
      const elements = this.parent.querySelectorAll(
        '.featuredProductSlider'
      );

      elements.forEach((element) => {
        // Prevent duplicate initialization
        if (element.dataset.initialized === 'true') return;

        element.dataset.initialized = 'true';

        this.swiper(element);
      });
    }

    swiper(element) {
      const loop = element.dataset.loop === 'true';
      const autoplayEnabled = element.dataset.autoplay === 'true';
      const time =
        parseInt(element.dataset.autoplayTime || 0, 10) * 1000;

      const navigationEnabled =
        element.dataset.navigation === 'true';

      const paginationDesktop =
        element.dataset.paginationDesktop === 'true';

      const paginationMobile =
        element.dataset.paginationMobile === 'true';

      const isMobileViewport = window.innerWidth < 749;
      const halfSlide = element.dataset.halfSlide === 'true';

      const elId = element.dataset.id;

      /*
       * Slides per view
       *
       * Mobile (< 749px)
       * - Uses mSlidePerView
       * - halfSlide adds 0.2
       *
       * Tablet (749px - 989px)
       * - Always 2.5
       *
       * Desktop (990px+)
       * - Uses slidePerView
       * - halfSlide adds 0.5
       */
      let slidesPerView = parseFloat(
        element.dataset.slidePerView
      );

      if (isMobileViewport) {
        slidesPerView = parseFloat(
          element.dataset.mSlidePerView
        );

        if (halfSlide) {
          slidesPerView += 0.2;
        }
      } else if (window.innerWidth < 990) {
        slidesPerView = 2.5;
      } else if (halfSlide) {
        slidesPerView += 0.5;
      }

      /*
       * Navigation
       */
      const navigation = navigationEnabled
        ? {
            nextEl: `.${elId} .swiper-button-next`,
            prevEl: `.${elId} .swiper-button-prev`,
          }
        : false;

      /*
       * Pagination
       *
       * Find pagination only inside the current
       * slider wrapper so multiple sliders on the
       * same page do not interfere with each other.
       */
      const wrapper = element.closest(
        '.featured-product-slider-wrapper'
      );

      const paginationElement = wrapper
        ? wrapper.querySelector('.swiper-pagination')
        : null;

      const showPagination = isMobileViewport
        ? paginationMobile
        : paginationDesktop;

      const pagination =
        showPagination && paginationElement
          ? {
              el: paginationElement,
              clickable: true,
            }
          : false;

      /*
       * Autoplay
       */
      const autoplay = autoplayEnabled
        ? {
            delay: time,
            disableOnInteraction: false,
          }
        : false;

      /*
       * Initialize Swiper
       */
      new Swiper(element, {
        loop,
        slidesPerView,
        spaceBetween: 8,
        navigation,
        pagination,
        autoplay,

        breakpoints: {
          768: {
            spaceBetween: 8,
          },

          990: {
            spaceBetween: 10,
          },

          1025: {
            spaceBetween: 12,
          },
        },
      });
    }
  }

  /*
   * Expose globally
   */
  window.FeaturedProductSlider = FeaturedProductSlider;

  /*
   * Initialize all sections
   *
   * querySelectorAll ensures every instance of
   * .featured-product-slider on the page is initialized.
   */
  const init = (container = document) => {
    container
      .querySelectorAll('.featured-product-slider')
      .forEach((section) => {
        new FeaturedProductSlider(section);
      });
  };

  /*
   * Initial page load
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      init();
    });
  } else {
    init();
  }

  /*
   * Shopify Theme Editor / Section reload
   */
  document.addEventListener(
    'shopify:section:load',
    (event) => {
      if (event.target) {
        init(event.target);
      }
    }
  );
})();
